module.exports = __webpack_public_path__ + "img/selectedBureau.074c0693.svg";